import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import ListExperience from './ListExperience'

import EditExperience from './EditExperience'
import NewExperience from './NewExperience'

const SpecialistExperienceRoutes = () => {

  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListExperience /></PrivateRoute7>} />
        <Route path="edit-experience" element={<PrivateRoute7><EditExperience /></PrivateRoute7>} />
        <Route path="new-experience" element={<PrivateRoute7><NewExperience /></PrivateRoute7>} />
    </Routes>
  )
}

export default SpecialistExperienceRoutes